// extracted by mini-css-extract-plugin
export default {"fitness-training":"fitness_fitness-training__VlFyP","section-head":"fitness_section-head__4xVLH","boxes-container":"fitness_boxes-container__KrrjY"};